import React, { ReactNode, useEffect, useState } from 'react';
import './Scene.css';

export interface SceneProps {
  /** Optional licensed or original scene image. Failure keeps the navy tint. */
  src?: string;
  /** CSS object-position for the image crop. */
  position?: string;
  className?: string;
  children: ReactNode;
}

/**
 * Fixed decorative ground behind migrated customer surfaces. Gradient A is
 * the fallback tint; the image, when present, sits under a contrast scrim.
 * Purely decorative: hidden from assistive tech and inert to pointers.
 */
const Scene: React.FC<SceneProps> = ({ src, position, className, children }) => {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  useEffect(() => {
    setFailedSource(null);
  }, [src]);
  const showImage = Boolean(src) && failedSource !== src;

  return (
    <div className={`luma-theme luma-scene-root${className ? ` ${className}` : ''}`}>
      <div className="luma-scene" aria-hidden="true" data-testid="luma-scene">
        {showImage && (
          <img
            className="luma-scene__image"
            src={src}
            alt=""
            decoding="async"
            style={position ? { objectPosition: position } : undefined}
            onError={() => setFailedSource(src ?? null)}
          />
        )}
        <div className="luma-scene__scrim" />
      </div>
      <div className="luma-scene__content">{children}</div>
    </div>
  );
};

export default Scene;
